import SectionType from '@/models/sectionType'
import Briefing from '@/models/briefing'
import { request } from '@/utils/request'

export function getSectionTypesList () {
  return request({
    url: 'section-types',
    method: 'get'
  }).then(sections => {
    return sections.map(section => SectionType.assign(section))
  })
}

export function getSectionCopySettings () {
  return request({
    url: 'section-copy-settings',
    method: 'get'
  })
}

export function reloadSection (briefingId, sectionCode) {
  return request({
    url: 'update-section',
    method: 'post',
    data: { briefingId, sectionCode },
  }).then((briefing) => {
    return briefing ? Briefing.assign(briefing) : null
  })
}

export function ignoreChangedSection (briefingId, sectionId) {
  return request({
    url: 'section/ignore',
    method: 'post',
    data: { briefingId, sectionId },
  }).then((briefing) => {
    return briefing ? Briefing.assign(briefing) : null
  })
}

export function applyChangedSection (briefingId, sectionId) {
  return request({
    url: 'section/apply',
    method: 'post',
    data: { briefingId, sectionId },
  }).then((briefing) => {
    return briefing ? Briefing.assign(briefing) : null
  })
}

export function sendSectionCommand (briefingId, sectionId, command, params) {
  return request({
    url: 'section/command',
    method: 'post',
    data: {
      briefingId,
      sectionId,
      command,
      params
    },
    expectedErrorCodes: [506]
  }).then((briefing) => {
    return briefing ? Briefing.assign(briefing) : null
  })
}
